window.addEventListener("load", function(event) {
  let price = document.querySelector('p.modal_price')
  let unavailable = document.querySelector('span.sold_out');
  const sizeSelector = document.querySelector('[data-option=option1]');
  const checkoutButton = document.querySelector('.add_to_cart');
  const optionEl = document.createElement('option');
    
  optionEl.textContent = '** SELECT A SIZE **';
  sizeSelector.prepend(optionEl);
  optionEl.selected = 'selected';
    
  let productVariants = meta.product.variants;
  let variantPrice = '$ ' + (productVariants[0].price  / 100).toFixed(2);

  function disableButton(){
        checkoutButton.style.opacity = ".75";
        checkoutButton.style.cursor = "notAllowed";
        checkoutButton.innerHTML = "SELECT A SIZE";
        checkoutButton.disabled = true;
  }

  function enableButton(){
        checkoutButton.style.opacity = "1";
        checkoutButton.style.cursor = "pointer";
        if (unavailable.innerHTML == "Out of Stock") {
            checkoutButton.innerHTML = "Out of Stock";
        } else {
            checkoutButton.innerHTML = "Add to Cart";
        }
        checkoutButton.disabled = false;
  }

  function resetDefaultPrice() {
        unavailable.textContent = (variantPrice)
        unavailable.style.fontWeight = '400'
        unavailable.style.color = '#666'
  }

  function updateUI() {
        if (sizeSelector.selectedOptions[0].textContent === '** SELECT A SIZE **'){
            disableButton();
            resetDefaultPrice();
        } else {
            enableButton();
        }
  }

  sizeSelector.addEventListener('change', updateUI);
  disableButton();
    
  price.addEventListener('change', function (event) {
    console.log(event.target.value);
  })
});